import i18n from 'i18next';
import request from './index';
import { packagePropertiesMutation, packagePropertiesRows } from '../helpers/packagePropertiesResponse';

const options = { timeout: 20000 };
const unavailable = () => i18n.t('PackagePropertiesApiUnavailable');

const read = url => request.get(url, options)
    .then(response => packagePropertiesRows(response, unavailable()));
const mutate = (method, url, body) => request[method](url, body, options)
    .then(response => packagePropertiesMutation(response, unavailable()));

export const getPackageProperties = () => read('/admin/subscr_pkg_props');
export const getPackagePropertyValues = packageId => read(`/admin/supscription/package/${packageId}/properties`);
export const createPackageProperty = values => mutate('post', '/admin/subscr_pkg_props', values).then(response => {
    if (response.data?.id == null) throw new Error(unavailable());
    return { ...values, ...response.data };
});
export const updatePackageProperty = (id, values) => mutate('put', `/admin/subscr_pkg_props/${id}`, values);
export const deletePackageProperty = id => request.delete(`/admin/subscr_pkg_props/${id}`, options)
    .then(response => packagePropertiesMutation(response, unavailable()));
export const savePackagePropertyValues = (packageId, properties) => mutate('put', `/admin/supscription/package/${packageId}/properties`, { properties });
